export default __webpack_public_path__ + "static/media/Footpad's Wristbands of the Sundered Crown.afc42649.jpg";